import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

// Store
import {
  loadPaymentCards,
  loadPaymentCardsSuccess,
  loadPaymentCardsError,
  deleteCard,
  deleteCardSuccess,
  deleteCardError,
} from './payments.actions';
import { toggleLoaderState } from '../loader/loader.actions';

// Services
import { SystemNotificationsService } from '@services/system-notifications.service';
import { PaymentsService } from '@services/payments.service';

@Injectable()
export class PaymentsEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store);
  private systemNotificationsService = inject(SystemNotificationsService);
  private paymentsService = inject(PaymentsService);
  private dialog = inject(MatDialog);
  private translateService = inject(TranslateService);

  loadPayments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPaymentCards),
      switchMap(() =>
        this.paymentsService.userGetCards().pipe(
          map(cards => loadPaymentCardsSuccess({ cards })),
          catchError(error => {
            return of(loadPaymentCardsError({ error }));
          }),
        ),
      ),
    ),
  );

  deleteCard$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteCard),
      switchMap(({ cardId }) => {
        this.store$.dispatch(toggleLoaderState({ state: true }));

        return this.paymentsService.deleteUserCard(cardId).pipe(
          map(() => {
            this.dialog.closeAll();
            this.store$.dispatch(toggleLoaderState({ state: false }));
            this.systemNotificationsService.openSuccessSnackBar(
              this.translateService.instant('profile.card-page.delete-success'),
            );
            return deleteCardSuccess({ cardId });
          }),
          catchError(error => {
            this.dialog.closeAll();
            this.store$.dispatch(toggleLoaderState({ state: false }));
            this.systemNotificationsService.openErrorSnackBar(
              this.translateService.instant('profile.card-page.delete-failed'),
            );
            return of(deleteCardError({ error }));
          }),
        );
      }),
    ),
  );
}
